(function($) {
    window._ajaxCountNestedQueries = 0;

    $.caAjax = function( url, options ){
        if ( typeof url === "object" ) {
            options = url;
            url = undefined;
        }

        options = options || {};

        var loadingSplash = options.loadingSplash ? true : false;
        if(loadingSplash){
            $('body').caLoadingSplash('show');
            _ajaxCountNestedQueries++;
        }

        var prevErrorHandler = options.error;
        if(!$.isArray(prevErrorHandler)) prevErrorHandler = [prevErrorHandler];
        options.error = $.merge([function(jqXHR, textStatus, errorThrown){

            throw 'Server connection error: ' + textStatus ;

        }], prevErrorHandler);

        var prevCompleteHandler = options.success;
        if(!$.isArray(prevCompleteHandler)) prevCompleteHandler = [prevCompleteHandler];
        options.success = $.merge([function(jqXHR, textStatus, errorThrown){

            if(loadingSplash){
                _ajaxCountNestedQueries--;
                if (_ajaxCountNestedQueries == 0) {
                    $('body').caLoadingSplash('hide');
                }
            }

        }], prevCompleteHandler);

        var prevSuccessHandler = options.success;
        if(!$.isArray(prevSuccessHandler)) prevSuccessHandler = [prevSuccessHandler];
        options.success = $.merge([function(jqXHR, textStatus, errorThrown){

            // empty

        }], prevSuccessHandler);

        $.ajax(options);

    }

    $.caPost = function( url, data, callback, type, loadingSplash ){
        var loadingSplash = (loadingSplash == false) ? false : true;

        if(loadingSplash){
            $('body').caLoadingSplash('show');
            _ajaxCountNestedQueries++;
        }
        $.post( url, data, callback, type)
            .fail(function(jqXHR, textStatus){
                $.caAlert('Server connection error: ' + textStatus, 'Error');
                //throw 'Server connection error: ' + textStatus ;
            })
            .always(function(){
                if(loadingSplash){
                    _ajaxCountNestedQueries--;
                    if (_ajaxCountNestedQueries == 0) {
                        $('body').caLoadingSplash('hide');
                    }
                }
            });
    };
    
    $.caGet = function( url, data, callback, type, loadingSplash ){
        var loadingSplash = (loadingSplash == false) ? false : true;

        if(loadingSplash){
            $('body').caLoadingSplash('show');
        }
        
        $.get( url, data, callback, type)
            .fail(function(jqXHR, textStatus){
                throw 'Server connection error: ' + textStatus ;
            })
            .always(function(){
                if(loadingSplash){
                    $('body').caLoadingSplash('hide');
                }
            });
    };
    
    $.caAjaxInModal = function(url, data, title, width, height, type, loadingSplash, customClass) {
        var callback = function(response) {
            var dialogWrapper = $('<div></div>').appendTo('body');
            dialogWrapper.html(response);

            dialogWrapper.caDialog({
                title: title,
                width : width,
                height : height,
                dialogClass: customClass,
                staticForm: false
            });
        };
        
        $.caPost(url, data, callback, type, loadingSplash); 
    };

    $.caIframeInWindow = function(url, data, title) {
        // This is needed in order to get around Safari blocking popups.
        // @see https://stackoverflow.com/a/25050893
        const popupTest = window.open(
            '',
            'popupWindow',
            'name="' + title +  '",resizable=yes,status=yes,toolbar=no,location=no' +
            ',menubar=no' +
            ',width=1100,height=800'
        );
        popupTest?.document.write('Loading Payment Info...');

        const popup = window.open(
            url,
            'popupWindow'
        );

        // Add event listener for closePOSIframeDialog
        window.addEventListener('message', function(event) {
            if (event.origin === window.location.origin && event.data.action === 'closePOSIframeDialog') {
                var params = event.data.params;

                // Close the popup window
                if (popup && !popup.closed) {
                    popup.close();
                }

                if (params.callbackJs) {
                    if (params.callbackJs === '_attendancePayCallback') {
                        if ($.isFunction($.fn.caStandAloneRoster)) {
                            $('.content-wrapper').caStandAloneRoster(
                                'attendancePayCallback',
                                params.callbackJsParams
                            );
                        }
                    } else if (params.callbackJs === 'reload_courts') {
                        $j('#btnRefresh').trigger('change');
                    } else if (params.callbackJs === 'reload') {
                        location.reload();
                    }
                }
            }
        });
    };

    $.caPostToDiv = function( url, data, divObj, callback, type, loadingSplash){
        var postCallBack = function (response) {
            $(divObj).html(response);

            if (typeof(callback) === 'function') {
                callback(response);
            }
        }

        $.caPost(url, data, postCallBack, type, loadingSplash);
    };

    $.caAjaxApi = function( url, data, callback, options ){
        var loadingSplash = typeof options.loadingSplash === 'undefined'
            ? $('body').data('caCaLoadingSplash')
            : options.loadingSplash;

        if(loadingSplash){
            $('body').caLoadingSplash('show');
            _ajaxCountNestedQueries++;
        }

        var dataType = options.dataType || 'json';
        var auth = options.auth || null;

        if (typeof options.contentType !== 'undefined' && options.contentType === "application/json" && typeof data !== "string" ) {
            data = JSON.stringify(data);
        }
        var ajaxOptions = {
            type: options.type || "POST",
            url: url,
            data: data,
            dataType: dataType
        };
        if (typeof options.contentType !== 'undefined') {
            ajaxOptions.contentType = options.contentType;
        }
        var beforeSend = null;

        if (auth === 'basic') {
            beforeSend = function(xhr) {
                xhr.setRequestHeader ("Authorization", "Basic " + btoa(options.username + ":" + options.password));
            }
        } else if (auth === 'bearer') {
            beforeSend = function (xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + options.token);
            };
        }

        if (beforeSend) {
            ajaxOptions.beforeSend = beforeSend;
        }

        if (typeof callback !== "function") {
            callback = function() {}
        }

        $.ajax(ajaxOptions)
            .done(function (response) {
                callback(response);
            })
            .fail(function(response, textStatus) {
                var errors = null;
                if (response && response.responseText) {
                    var responseJson = JSON.parse(response.responseText);
                    errors = responseJson.errors || responseJson.error_description || responseJson.error || responseJson.message;
                } else if (response && response.error) {
                    errors = response.errors;
                }
                if (errors) {
                    $.caAlert(errors);
                    if(typeof options.callingFrom !== 'undefined' && options.callingFrom === 'cardConnect') {
                        callback(response);
                    }
                    return;
                }
                $.caAlert('Server connection error: ' + textStatus);
            })
            .always(function(){
                if(loadingSplash){
                    _ajaxCountNestedQueries--;
                    if (_ajaxCountNestedQueries === 0) {
                        $('body').caLoadingSplash('hide');
                    }
                }
            });
    };
})(jQuery);
